module.exports = __webpack_public_path__ + "img/bimistock----------------------------------------------------@1x.07854134.png";